import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Input, Form } from "antd";
import React, { useState } from "react";
import { LoginResultSuccess, login } from "../API/Auth";

/**
 * Props for the LoginForm component
 * @see LoginForm
 */
export interface LoginFormProps {
  // Called on successful login
  onLogin(
    userId: number,
    fullName: string,
    email: string,
    isAdmin: boolean
  ): void;
  // Called on unsuccesful login
  onError(error: "wrong-password" | "inactive-account" | "server-error"): void;
}

/**
 * Form for handling logins
 * This component will handle calling login() on the server and will call
 * onLogin() or onError() from the props depending on the result.
 */
export const LoginForm: React.FunctionComponent<LoginFormProps> = (props) => {
  // State for loading spinner
  const [isLoading, setLoading] = useState<boolean>(false);

  // Form instance
  const [form] = Form.useForm();

  // Callback on form submission -> login
  const onLogin = async () => {
    // Make login request
    setLoading(true);
    const loginResult = await login(
      form.getFieldValue("email"),
      form.getFieldValue("password")
    );
    setLoading(false);

    // Act on result
    if (loginResult.status === "ok") {
      // TODO Use discriminate union for result
      const result = loginResult as LoginResultSuccess;
      const userId = result.userId;
      const fullName = result.fullName;
      const isAdmin = result.isAdmin;

      props.onLogin(userId, fullName, form.getFieldValue("email"), isAdmin);
    } else {
      props.onError(loginResult.status);
    }
  };

  return (
    <Form
      hideRequiredMark={true}
      layout="vertical"
      form={form}
      onFinish={onLogin}
      initialValues={{ remember: true }}
    >
      <Form.Item name="email" required>
        <Input
          type="email"
          placeholder="E-mail"
          prefix={<UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
        />
      </Form.Item>

      <Form.Item name="password" required>
        <Input
          type="password"
          placeholder="Password"
          prefix={<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
        />
      </Form.Item>

      {/* <Form.Item name="remember" valuePropName="checked">
        <Checkbox>Remember me</Checkbox>
      </Form.Item> */}

      <Button
        type="primary"
        htmlType="submit"
        block={true}
        loading={isLoading}
        className="login-form-button"
      >
        Login
      </Button>
    </Form>
  );
};
